// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__AdtSK","modal":"Modal_modal__ZPo0N","Center":"Modal_Center__YvZql","BottomRight":"Modal_BottomRight__LwY7p","closeButton":"Modal_closeButton__ZP9rl"};